import React from 'react';
import { Car, XCircle } from 'lucide-react';

const CarUnavailableIcon = () => (
  <div className="relative w-10 h-10">
    <Car size={36} className="text-gray-700" />
    <XCircle
      size={16}
      className="absolute top-0 right-0 bg-white rounded-full"
    />
  </div>
);

export default CarUnavailableIcon;
